import "./TextInput.css";
import { ErrorSpan } from "./ErrorSpan";
import { ChangeEvent, FocusEvent, ReactNode } from "react";

interface TextInputProps {
  name: string;
  label: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  icon?: ReactNode;
  type: string;
  errorText?: string;
  id?: string;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  handleEyeClick?: () => void;
  showPassword?: boolean;
}

export function TextInput({
  name,
  label,
  value,
  onChange,
  icon,
  type,
  errorText,
  id,
  onBlur,
  handleEyeClick,
  showPassword = false,
}: TextInputProps) {
  return (
    <div className="form-group">
      <input
        type={
          ["password", "Password", "confirmPassword"].includes(name) &&
          showPassword
            ? "text"
            : type
        }
        name={name}
        id={id}
        className=""
        placeholder="."
        onChange={onChange}
        value={value}
        onBlur={onBlur}
      />
      {icon}
      <label
        id="animation"
        data-error="wrong"
        data-success="right"
        htmlFor={id}
      >
        {label}
      </label>
      <span>
        <ErrorSpan message={errorText || ""} />
      </span>
      {type === "password" && handleEyeClick && (
        <button
          type="button"
          onClick={handleEyeClick}
          aria-label="Toggle password visibility"
          className="eye-icon"
        >
          <i
            className={`bi ${
              showPassword ? "bi-eye-fill" : "bi-eye-slash-fill"
            }`}
          ></i>
        </button>
      )}
    </div>
  );
}
